import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../../environments/environment';
import {DetailPopupRequestModel} from './detail-popup-request.model';
import {ProductOverviewRequest} from '../../../../../services/product-overview/product-overview-request.model';

@Injectable({
  providedIn: 'root',
})
export class DetailPopupService {

  civServicesBaseUrl;

  constructor(private http: HttpClient) {
    this.civServicesBaseUrl = environment.civServicesBaseURL;
  }

  getComposedAccountPopup(url: string) {
    const popupURL = this.civServicesBaseUrl + url;
    const headers = this.createHeaders();
    const requestBody = this.createRequestBody();
    return this.http.post<any>(popupURL, requestBody, { headers });
  }

  getContinentPopup(url: string) {
    const popupURL = this.civServicesBaseUrl + url;
    const headers = this.createHeaders();

    const requestBody = {
      arrangementNumber: DetailPopupRequestModel.arrangementNumber,
      administrationCode: DetailPopupRequestModel.administrationCode,
    };

    return this.http.post<any>(popupURL, requestBody, { headers });
  }

  createRequestBody(): string {
    if (!DetailPopupRequestModel) {
      return;
    }

    const requestBody = {
      arrangementNumber: DetailPopupRequestModel.arrangementNumber,
      bankCode : DetailPopupRequestModel.bankCode,
      tableNumber: DetailPopupRequestModel.tableNumber,
      relationRestrictedDataView: DetailPopupRequestModel.relationRestrictedDataView,
      restrictedDataViewException: DetailPopupRequestModel.restrictedDataViewException,
      relationMarketSegmentCode : DetailPopupRequestModel.relationMarketSegmentCode
    };

    return JSON.stringify(requestBody);
  }

  createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', ProductOverviewRequest.token);
    headers = headers.append('MFA-Authorization', ProductOverviewRequest.token);
    headers = headers.append('Graph-Authorization', ProductOverviewRequest.graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

}
